<template>
  <div class="alert alert-dark text-center text-dark" role="alert">
    <span v-if="!selectAllPages && selectedCount < count">
      <strong>{{ selectedCount }}</strong> items on this page are selected
      <button size="sm" @click="toggleSelectOnAllPages" class="btn btn-sm btn-link text-info text-capitalize">Select all {{ count }} available</button>
    </span>
    <span v-else>
      <strong>{{ selectedCount }}</strong> items are selected in total
      <button size="sm" @click="clearSelection" class="btn btn-sm btn-link text-info text-capitalize">Clear selection</button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SelectionDisplay',
  props: {
    selectAllPages: Boolean,
    selectedCount: Number,
    count: Number
  },
  methods: {
    clearSelection() {
      this.$emit('clearSelection');
    },
    toggleSelectOnAllPages() {
      this.$emit('toggleSelection', true)
    }
  }
}
</script>
